/**
 * @file index.tsx
 *
 * @fileoverview Handles some specific behaviour for wrapping the job detail
 * for showing in a split view or in standalone.
 */

import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import { forwardRef } from "react";
import styles from "./jobDetailWrapper.module.scss";

const jobDetailWrapper = cva([styles.detailWrapper], {
  variants: {
    overflow: {
      true: styles.overflow,
    },
    isIframe: {
      true: styles.isIframe,
    },
  },
});

interface JobDetailWrapperProps extends VariantProps<typeof jobDetailWrapper> {
  type: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

// Refactor component as React.forwardRef
export const JobDetailWrapper = forwardRef(function (
  { children, overflow, isIframe, ...props }: JobDetailWrapperProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div
      className={jobDetailWrapper({ overflow, isIframe: overflow && isIframe })}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
});

export default JobDetailWrapper;
